const Productos = ({productsItem, newAddProduct}) => {
  return (
    <div className='products'>
        {productsItem.map((products) =>(            
                <div key={products.id}  class="card" style={{width: '15rem'}}>
                  <div className='card-img-grid-1'>
                     <img src={products.img} class="card-img" alt={products.name}/>
                  </div>
                  <div class="card-body">
                      <h6 class="card-title">{products.name}</h6>
                      <p class="card-text"> $ {products.price} </p>
                  </div>
                  <div className='card-img-grid-3'>
                      <button className="button-addCart" onClick={() => newAddProduct(products)}>
                          Añadir al carrito
                      </button>
                  </div>
                </div>   
            ) ) }
    </div>
  );
};
export default Productos;